// extracted by mini-css-extract-plugin
export default {"no-results":"no-results","no-results-text":"no-results-text"};